<template>
  <div :id="id || 'containerPedido'" v-if="selecionado && selecionado.cliente">
    <div class="text-center mb-2">
      <b class="h4">{{selecionado.nome_fantasia}}</b>
      <div v-if="!selecionado.data_agendamento && selecionado.previsao">
        Previsão de {{selecionado.tipo_pedido === '1' ? 'entrega' : 'retirada'}}: <b>{{getPrevisao}}</b>
      </div>
      <div>
        <div>{{selecionado.data_pedido}} <span v-if="selecionado.comanda"> | PDV: {{selecionado.comanda.id_contador || selecionado.comanda.id_comanda}}</span></div>
        <b class="text-primary" v-if="selecionado.update_at">***PEDIDO EDITADO***</b>
        <b class="text-secondary" v-if="selecionado.status === '5'">***PEDIDO CANCELADO***</b>
      </div>
    </div>
    <hr class="hide">
    <div class="border text-center">
      <b class="">PEDIDO: {{selecionado.id_contador}}</b>
      <div v-if="selecionado.data_agendamento">
        <b class="text-secondary">***PEDIDO AGENDADO***</b>
        <div>{{selecionado.data_agendamento}}</div>
      </div>
      <hr class="hide">
    </div>
    <h6 class="text-card" v-if="selecionado.status === '5'">
      <b class="text-danger">Cancelado:</b> {{selecionado.obs_cancelamento ? selecionado.obs_cancelamento : 'Pedido cancelado pelo cliente'}}
    </h6>
    <div v-if="pedidoIntegrado" class="border">
      <div class="d-flex align-items-center">
        <div class="d-print-none" style="margin-right: 6px" v-if="preview">
          <img v-if="iconePlataforma" :alt="plataforma" :src="iconePlataforma" class="mx-2 integration-icon">
        </div>
        <div>
          <b>Pedido {{ plataforma }}</b>
          <div class="small">Identificador: {{ identificadorIntegracao }}</div>
        </div>
        <a href="#" class="ml-auto d-print-none text-decoration-none text-primary small" @click="$emit('modalIntegracao')" v-if="preview">
          Logs do Pedido
        </a>
      </div>
      <div v-if="payloadNormalizado" class="small">
        <hr>
        <div v-for="pay in metodosPagamentoNormalizados" :key="`${pay.metodo_externo}-${pay.valor}`">
          Pagamento {{ pay.prepaid ? 'Online' : 'na Entrega' }}<span v-if="pay.bandeira"> ({{ pay.bandeira }})</span>: {{ pay.valor | valor }}
        </div>
        <div v-for="(beneficio, index) in beneficiosNormalizados" :key="`beneficio-${beneficio.tipo}-${index}`">
          Desconto<span v-if="beneficio.patrocinadores && beneficio.patrocinadores.length">
            (<span v-for="(patrocinador, patrocinadorIndex) in beneficio.patrocinadores" :key="`patrocinador-${patrocinador.tipo}-${patrocinadorIndex}`"><span v-if="patrocinadorIndex"> + </span>{{ patrocinador.tipo }}: {{ patrocinador.valor | valor }}</span>)
          </span>: {{ beneficio.valor | valor }}
        </div>
        <div v-for="(taxa, index) in taxasNormalizadas" :key="`taxa-${taxa.tipo}-${index}`">
          {{ taxa.nome || taxa.tipo }}: {{ taxa.valor | valor }}
        </div>
        <div v-if="documentoClienteNormalizado">
          Incluir {{ documentoClienteNormalizado.tipo || 'documento' }} na nota: {{ documentoClienteNormalizado.numero }}
        </div>
        <div v-if="fulfillmentNormalizado">
          <div v-if="fulfillmentNormalizado.entregue_por">
            Entregue por: {{ fulfillmentNormalizado.entregue_por === 'MERCHANT' ? 'Loja' : `Parceiro ${plataforma}` }}
          </div>
          <div v-if="fulfillmentNormalizado.observacao">Obs: {{ fulfillmentNormalizado.observacao }}</div>
          <div v-if="fulfillmentNormalizado.pickup_code">Código de Coleta: {{ fulfillmentNormalizado.pickup_code }}</div>
        </div>
        <div v-for="(info, index) in extraInfoNormalizado" :key="`extra-info-${index}`">
          {{ info.label || info.key }}: {{ info.value }}
        </div>
        <div v-if="pedidoTesteNormalizado"><b>***PEDIDO DE TESTE***</b></div>
      </div>
      <div v-else-if="selecionado.json_ifood" class="small">
        <hr>
        <div v-if="selecionado.json_ifood && selecionado.json_ifood.payments && selecionado.json_ifood.payments.methods" v-for="pay in selecionado.json_ifood.payments.methods">
          Pagamento {{ pay.prepaid ? 'Online' : 'na Entrega' }}<span v-if="pay.card"> ({{ pay.card.brand }})</span>: {{ pay.value | valor }}
        </div>
        <div v-if="selecionado.json_ifood.benefits" v-for="benefits in selecionado.json_ifood.benefits">
          Desconto (<span v-for="sponsor in benefits.sponsorshipValues" v-if="sponsor.value > 0">{{ sponsor.name === 'MERCHANT' ? 'LOJA' : 'IFOOD' }}</span>): {{ benefits.value | valor }}
        </div>
        <div v-if="selecionado.json_ifood.customer.documentNumber">
          Incluir CPF na nota: {{ selecionado.json_ifood.customer.documentNumber }}
        </div>
        <div v-if="selecionado.json_ifood.total.additionalFees">
          Taxa Adicional: {{ selecionado.json_ifood.total.additionalFees | valor }}
        </div>
        <div v-if="selecionado.json_ifood.delivery">
          <div>Entregue por: {{ selecionado.json_ifood.delivery.deliveredBy === 'MERCHANT' ? 'Loja' : 'Parceiro iFood' }}</div>
          <div v-if="selecionado.json_ifood.delivery.observations">Obs: {{ selecionado.json_ifood.delivery.observations }}</div>
          <div v-if="selecionado.json_ifood.delivery.pickupCode">Código de Coleta: {{ selecionado.json_ifood.delivery.pickupCode }}</div>
        </div>
        <div v-if="selecionado.json_ifood.extraInfo">{{ selecionado.json_ifood.extraInfo }}</div>
        <div v-if="selecionado.json_ifood.customer.phone">
          Suporte iFood: <a :href="`tel:${selecionado.json_ifood.customer.phone.number}`" class="text-info text-decoration-none">{{ selecionado.json_ifood.customer.phone.number }}</a> |
          {{ selecionado.json_ifood.customer.phone.localizer }}
        </div>
        <div v-if="origin === 6 && preview" class="d-print-none">
          <a :href="`https://gestordepedidos.ifood.com.br/#/home/orders/now/${selecionado.ifood_id}`" class="text-primary text-decoration-none" target="_blank">
            <i class="fa fa-headset"></i> Chat com o Cliente
          </a>
        </div>
      </div>
      <hr class="hide">
    </div>
    <div class="alert alert-danger border-0 text-dark p-2 mb-2" v-if="selecionado.suspeito === '1'">
      <div class="d-flex align-items-center">
        <div>
          <b>CLIENTE BLOQUEADO</b>
          <div class="small">
            Recomendamos revisar este pedido.
          </div>
        </div>
        <div class="d-print-none ml-auto" v-if="preview">
          <a v-if="selecionado.suspeito === '1'" class="btn btn-info btn-sm" href="javascript:" @click="$emit('toggleCliente')">
            <i class="fa fa-lock-open"></i><br>Desbloquear
          </a>
        </div>
      </div>
      <hr class="hide">
    </div>
    <div class="border" v-if="selecionado.cliente.nome_cliente">
      <div class="d-print-none right" v-if="selecionado.tipo_cliente !== '2' && selecionado.suspeito !== '1' && preview">
        <a class="btn btn-secondary btn-sm px-3" href="javascript:" title="Bloquear cliente" @click="$emit('toggleCliente')">
          <i class="fa fa-lock"></i>
        </a>
      </div>
      <div>
        <b>{{selecionado.cliente.nome_cliente}}</b>
        <div class="small">
          <div v-if="selecionado.tipo_cliente !== '2'">
            Nº de Pedidos: {{!parseInt(selecionado.qtd_pedidos || '0') ? 'Primeiro pedido' : selecionado.qtd_pedidos + ' pedidos'}}
          </div>
          <div v-if="selecionado.cliente.telefone">
            Telefone:
            <span v-if="!preview">{{selecionado.cliente.telefone | phone}}</span>
            <a :href="'https://api.whatsapp.com/send?phone=55'+ selecionado.cliente.telefone" class="text-info text-decoration-none" target="_blank" v-else>
              {{selecionado.cliente.telefone | phone}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <hr class="hide">
    <div class="border" v-if="selecionado.tipo_pedido === '3' || selecionado.nolocal">
      <b>{{selecionado.nolocal}}</b>
      <div>{{ selecionado.tipo_pedido === '2' ? 'PARA LEVAR' : 'CONSUMIR NO LOCAL' }}</div>
    </div>
    <div class="border" v-else-if="selecionado.tipo_pedido === '2'">
      <b class="text-primary">
        <img src="../../assets/icons/walking.svg" class="d-print-none mr-1" v-if="preview">
        RETIRAR NO LOCAL
      </b>
      <div>Cliente vai retirar o pedido</div>
    </div>
    <div class="border" v-else-if="selecionado.tipo_pedido === '1'">
      <div class="d-flex justify-content-between align-items-center">
        <div class="mr-1">
          <b class="text-success">
            <img src="../../assets/icons/moto.svg" class="d-print-none mr-1" v-if="preview">
            ENTREGAR PEDIDO
          </b>
          <div>
            {{selecionado.cliente.logradouro}}, {{selecionado.cliente.numero}}, {{selecionado.cliente.bairro}},
            <span v-if="selecionado.cliente.complemento">{{selecionado.cliente.complemento}} - </span>
            <span>{{selecionado.cliente.nome_cidade}} - {{selecionado.cliente.sigla_estado}}</span>
            <div v-if="selecionado.zona">
              Área de entrega: <b>{{selecionado.zona.nome_zona}}</b>
            </div>
            <div v-if="selecionado.nome_entregador">
              <img src="../../assets/icons/helmet.svg" alt="Entregador" title="Entregador" class="d-print-none mr-1" v-if="preview">
              <span class="hide">Entregador: </span>
              <span v-if="!preview && selecionado.nome_entregador">{{ selecionado.nome_entregador }}</span>
              <a href="javascript:" class="text-success" title="Alterar entregador" v-else-if="selecionado.nome_entregador" @click="$emit('escolherEntregador', selecionado)">{{ selecionado.nome_entregador }}</a>
            </div>
          </div>
        </div>
        <div class="text-center d-print-none mr-1 px-2" v-if="preview">
          <a href="javascript:" class="text-success text-decoration-none" title="Ver o endereço no mapa" @click="linkMapa()">
            <img src="../../assets/icons/location-light.svg" style="width: 18px">
            <div class="small mt-1">Mapa</div>
          </a>
        </div>
      </div>
    </div>
    <hr class="hide">
    <div class="border">
      <div class="p-2 list-produto" v-for="i in selecionado.produtos">
        <b v-if="!i.id_beneficio" class="badge badge-dark right">{{(i.valor * i.quantidade) | valor}}</b>
        <span class="badge badge-warning right" v-else><i class="fa fa-trophy mr-1"></i> Benefício</span>
        <div v-if="desmembrarImpressao && i.quantidade < 5 && ((i.adicionais && i.adicionais.length) || (i.divisoes && i.divisoes.length))">
          <div class="mb-1" v-for="p in parseInt(i.quantidade)">
            <b>1x {{i.produto.nome_produto}}</b>
            <div class="ml-2">
              <div v-for="d in i.divisoes">
                # {{d.nome_produto}}
              </div>
              <div v-for="d in i.adicionais">
                + <b v-if="d.qtd > 1">{{parseFloat(d.qtd)}}x</b> {{d.nome_produto}}<span v-if="d.valor > 0">: {{d.qtd * d.valor | valor}}</span>
                <div v-if="d.adicionais">
                  <div class="ml-3" v-for="da in d.adicionais">
                    • <b v-if="da.qtd > 1">{{parseFloat(da.qtd)}}x</b> {{da.nome_produto}}<span v-if="da.valor > 0">: {{da.qtd * da.valor | valor}}</span>
                  </div>
                </div>
              </div>
              <b v-if="i.observacao">Observação: {{i.observacao}}</b>
            </div>
          </div>
        </div>
        <div v-else>
          <b>{{i.quantidade}}x {{i.produto.nome_produto}}</b>
          <div class="ml-2">
            <div v-for="d in i.divisoes">
              # {{d.nome_produto}}
            </div>
            <div v-for="d in i.adicionais">
              + <b v-if="d.qtd > 1">{{parseFloat(d.qtd)}}x</b> {{d.nome_produto}}<span v-if="d.valor > 0">: {{d.qtd * d.valor | valor}}</span>
            </div>
            <div v-if="i.observacao">Obs: <b>{{i.observacao}}</b></div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{'d-print-none': origin === 8}">
      <hr class="hide">
      <div v-if="selecionado.pagamento" class="border">
        <b>
          <img v-if="preview" class="d-print-none mr-1" src="../../assets/icons/payment.svg">
          <span v-if="selecionado.pedido_pago === '1'">PEDIDO JÁ PAGO</span>
          <span v-else-if="selecionado.pagamento.id_pagamento === '2'">PAGAMENTO A PRAZO</span>
          <span v-else-if="selecionado.pagamento.categoria === '5'">PAGAMENTO ONLINE</span>
          <span v-else>PAGAMENTO {{selecionado.tipo_pedido === '1' ? 'NA ENTREGA' : 'NA RETIRADA'}}</span>
        </b>
        <div v-if="selecionado.pagamento.categoria === '5'" class="small">
          Pedido pago via {{selecionado.nome_pagamento}}
          <a v-if="origin < 6 && preview" class="d-print-none text-decoration-none text-primary" href="javascript:" @click="$emit('openModalPagamento')">
            (Ver Pagamento)
          </a>
        </div>
        <div v-else class="small">
          <div v-if="selecionado.pedido_pago === '1'">O pagamento deste pedido já foi realizado</div>
          <div v-else-if="selecionado.pagamento.id_pagamento === '2'">O cliente irá efetuar o pagamento conforme combinado</div>
          <div v-else>O cliente ainda não realizou o pagamento deste pedido</div>
        </div>
        <hr class="hide">
      </div>
      <div class="border">
        <div>
          <span class="right">{{(parseFloat(selecionado.total) - parseFloat(selecionado.valor_frete)) - parseFloat(selecionado.valor_taxa ? selecionado.valor_taxa : 0) + parseFloat(selecionado.valor_desconto) | valor}}</span>
          SubTotal:
        </div>
        <div v-if="selecionado.ref_cupom">
          <b class="right">{{selecionado.ref_cupom}}</b>
          Cupom:
        </div>
        <div>
          <span class="right">{{selecionado.valor_desconto | valor}}</span>
          Desconto:
        </div>
        <div v-if="selecionado.tipo_pedido === '1'">
          <span class="right">{{selecionado.valor_frete | valor}}</span>
          Taxa de Entrega:
        </div>
        <div v-if="selecionado.valor_taxa && selecionado.valor_taxa !== '0'">
          <span class="right">{{(Math.abs(selecionado.valor_taxa)) | valor}}</span>
          {{selecionado.valor_taxa > 0 ? 'Taxa' : 'Desconto'}} Pagamento
        </div>
        <div v-if="origin !== 4 && selecionado.id_pagamento && selecionado.id_pagamento !== '5'">
          <span class="right">{{selecionado.nome_pagamento}}</span>
          Forma de Pagamento:
        </div>
        <div>
          <b class="right">{{selecionado.total | valor}}</b>
          <b v-if="selecionado.pagamento && selecionado.pagamento.categoria === '5'">Valor Pago:</b>
          <b v-else>Cobrar do Cliente:</b>
        </div>
      </div>
      <div v-if="selecionado.obs_pedido || selecionado.troco > 0">
        <hr class="hide">
        <div class="border">
          <b>Observações</b>
          <div class="small">
            <div v-if="selecionado.obs_pedido">- {{selecionado.obs_pedido}}</div>
            <div v-if="selecionado.troco > 0">- Valor a receber do cliente: {{(selecionado.troco) | valor}}</div>
            <div v-if="selecionado.troco && (parseFloat(selecionado.troco) > selecionado.total)">
              - {{ selecionado.tipo_pedido === '1' ? 'Levar de ' : 'Valor do '}} troco: {{(selecionado.troco - selecionado.total) | valor}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="hide">
    <div class="mt-4 text-center small hide">
      Automatizado por LeCard<br>
      <b>www.lecard.delivery</b>
    </div>
    <component is="style">.right{float:right}.mb-1{margin-bottom:6px}</component>
  </div>
</template>

<script>
import iconIfood from '@/assets/icons/ifood.svg';
import iconUaiRango from '@/assets/icons/uairango.svg';
import iconKeeta from '@/assets/icons/keeta.png';
import iconAiqFome from '@/assets/icons/aiqfome.svg';
import icon99Food from '@/assets/icons/99food.png';

export default {
  name: "CupomDelivery",
  props: ['selecionado', 'id', 'preview'],

  methods: {
    linkMapa() {
      const origin = `${this.empresa.lat_empresa},${this.empresa.long_empresa}`;
      const e = this.selecionado.cliente;
      const destination = (e.lat_endereco && e.long_endereco) ? `${e.lat_endereco},${e.long_endereco}`
        : encodeURI(`${e.logradouro}, ${e.numero || ''}, ${this.empresa.nome_cidade} - ${this.empresa.sigla_estado}`);
      const url = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}&travelmode=driving`;
      window.open(url, '_blank');
    }
  },

  computed: {
    desmembrarImpressao() {
      const config = this.$store.state.pdv.json_config || {};
      return config.desmembrar_itens !== '0';
    },

    empresa() {
      return this.$store.state.dataUser;
    },

    getPrevisao() {
      const previsao = this.selecionado.previsao;

      if (previsao) {
        return this.empresa.unidade_tempo !== '3' ? previsao.slice(-5) : `${previsao.substring(0, 10)}`;
      }
    },

    origin() {
      return parseInt(this.selecionado?.origin || '0')
    },

    payloadNormalizado() {
      return this.selecionado?.payload_normalizado || null;
    },

    pedidoIntegrado() {
      return !!this.payloadNormalizado || [6, 7, 9, 10, 11].includes(this.origin);
    },

    iconePlataforma() {
      const icones = {
        6: iconIfood,
        7: iconUaiRango,
        9: iconKeeta,
        10: iconAiqFome,
        11: icon99Food
      };

      return icones[this.origin] || null;
    },

    identificadorIntegracao() {
      return this.selecionado?.integrador_display
        || this.selecionado?.ifood_display
        || this.selecionado?.uairango_id
        || this.selecionado?.integracao?.external_display_id
        || this.payloadNormalizado?.integracao?.external_display_id
        || '';
    },

    metodosPagamentoNormalizados() {
      return this.payloadNormalizado?.pagamento?.metodos || [];
    },

    beneficiosNormalizados() {
      return this.payloadNormalizado?.beneficios || [];
    },

    taxasNormalizadas() {
      return this.payloadNormalizado?.taxas || [];
    },

    documentoClienteNormalizado() {
      const documento = this.payloadNormalizado?.cliente?.documento;
      return documento?.numero ? documento : null;
    },

    fulfillmentNormalizado() {
      return this.payloadNormalizado?.fulfillment || null;
    },

    extraInfoNormalizado() {
      const extraInfo = this.payloadNormalizado?.extra_info;
      return Array.isArray(extraInfo) ? extraInfo : [];
    },

    pedidoTesteNormalizado() {
      return this.payloadNormalizado?.pedido?.flags?.pedido_teste === true;
    },

    plataforma() {
      switch (this.origin) {
        case 1:
          return 'App/Site';
        case 2:
          return 'Geral';
        case 3:
          return 'Pedido Manual';
        case 4:
          return 'Qr Code';
        case 5:
          return 'WhatsApp';
        case 6:
          return 'iFood';
        case 7:
          return 'UaiRango';
        case 8:
          return 'Tablet';
        case 9:
          return 'Keeta';
        case 10:
          return 'AiqFome';
        case 11:
          return '99Food';
        default:
          return this.nomePlataformaIntegracao;
      }
    },

    nomePlataformaIntegracao() {
      const plataforma = this.selecionado?.integracao?.plataforma
        || this.payloadNormalizado?.integracao?.plataforma;

      if (!plataforma) return '';

      const nomes = {
        '99food': '99Food',
        'ifood': 'iFood',
        'uairango': 'UaiRango',
        'keeta': 'Keeta',
        'aiqfome': 'AiqFome'
      };

      return nomes[plataforma.toLowerCase()] || plataforma;
    }
  },

  filters: {
    valor(value) {
      const formatter = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL', minimumFractionDigits: 2});
      return value ? formatter.format(parseFloat(value)) : 'R$ 0,00';
    },

    phone(phone) {
      if (phone) {
        if (phone.length === 10) {
          return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

        } else if (phone.length === 11) {
          return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }
      }

      return phone
    },

    cep(value) {
      if (value && value.length === 8) {
        return value.substring(0,5) + '-' + value.substring(5);
      }
    }
  }
}
</script>

<style scoped>
.text-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  display: inline-block;
  padding: 6px;
  background-color: #fff;
  margin: 0 4px 8px 0;
  font-size: 0.8rem;
}

.border {
  border-radius: 4px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
}

.list-produto {
  border-bottom: 1px solid #dee2e6;
}

.list-produto:last-child {
  border: none;
}

.right {
  float: right;
}

.integration-icon {
  width: 32px;
}
</style>
